import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DashboardService } from "../_services/dashboard.service";
import { forkJoin, Subscription } from "rxjs";
import { MessagesControlService } from "src/app/_services/messages-control.service";
import { UserService } from "src/app/_services/user.service";
import { GlobalService } from "src/app/_services/global.service";
import { TranslateService } from "@ngx-translate/core";
import { DataService } from "src/app/dashboard/_services/data.service";
import moment from "moment";
import { MessagesService } from "src/app/messages-new/_services/messages.service";
declare var $: any;

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit, OnDestroy {
  attendanceLoading = true;
  pickupLoading = true;
  schoolLoading = true;
  reportFilter;
  activeBtn = "week";
  usingBlueride: number;
  notUsingBlueride: number;
  pickupReports;
  datesArray = [];
  active_users = [];
  not_active_users = [];
  not_using_ids_today = [];
  not_using_ids = [];
  onDate;

  schoolBusSystem: any = {};
  gradeNames = [];
  noOfpresentStudentsInEachGrade = [];
  noOfabsentStudentsInEachGrade = [];
  totalPresentStudents = 0;
  totalAbsentStudents = 0;

  barChartOptions;
  barChartLabels;
  barChartType = "bar";
  barChartLegend;
  barChartData;

  horizontalBarChartOptions;
  horizontalBarChartLabels;
  horizontalBarChartType = "horizontalBar";
  horizontalBarChartLegend;
  horizontalBarChartData;

  lineChartOptions;
  lineChartLabels;
  lineChartType;
  lineChartLegend;
  lineChartData;

  pieChartOptions;
  pieChartLabels;
  pieChartType;
  pieChartLegend;
  pieChartData;
  userPlan: string;
  filterSub;
  currLang;
  attendanceChartData;
  attendanceChartOptions;
  chartMaximumValues;
  constructor(
    private router: Router,
    private dashboardService: DashboardService,
    private globalService: GlobalService,
    private translate: TranslateService,
    private messagesControl: MessagesControlService,
    private dataService: DataService,
    private userService: UserService,
    private messagesService: MessagesService,
  ) {
    this.globalService.getLang().subscribe((lng) => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.filterSub = new Subscription();
  }

  ngOnDestroy(): void {
    this.filterSub.unsubscribe();

    const schoolId = localStorage.getItem("schoolId");
    // this.dashboardService.channelUnsubScribe([`dashboardDismissalTracking_${schoolId}`, `ddashboardDismissalProcess_${schoolId}`]);
  }

  ngOnInit(): void {
    // to remove the black screen and the stuck error msg popup if error message was just closed in sibling component
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
    (this.onDate = moment(new Date()).format("DD-MM")),
      this.dataService.getSchoolInfo().subscribe((res) => {
        this.userPlan = res[0].subscription_plan.is_free == 0 ? "paid" : "free";
      });

    this.globalService.getLang().subscribe((lng) => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    // user changed date
    this.userPlan = this.userService.userPlan;
    let x = this.dashboardService.getReportFilter().subscribe((res: any) => {
      if (res !== null) {
        this.reportFilter = res;
        this.getDashboard(this.reportFilter.toDate, this.activeBtn);
      }
    });
    this.filterSub.add(x);
  }

  getDashboard(date, pickupType) {
    // this.loading = true;
    this.schoolBusSystem = {};
    this.gradeNames = [];
    this.noOfpresentStudentsInEachGrade = [];
    this.noOfabsentStudentsInEachGrade = [];
    this.not_using_ids_today = [];
    this.not_using_ids = [];
    this.totalPresentStudents = 0;
    this.totalAbsentStudents = 0;

    this.dashboardService.getAttendanceReport(date).subscribe((res: any) => {
      res.map((grade) => {
        if (grade.students.present || grade.students.absent) {
          this.gradeNames.push(grade.name);
          this.noOfpresentStudentsInEachGrade.push(
            grade.students.present ? grade.students.present?.length : 0
          );
          this.noOfabsentStudentsInEachGrade.push(
            grade.students.absent? grade.students.absent?.length : 0
          );
          if (grade.students.present) {
            this.totalPresentStudents =
              this.totalPresentStudents + grade.students.present?.length;
          }
          if (grade.students.absent) {
            this.totalAbsentStudents =
              this.totalAbsentStudents + grade.students.absent?.length;
          }
        }
      });
      this.getMaximum2Arrays(this.noOfabsentStudentsInEachGrade,this.noOfpresentStudentsInEachGrade);
      this.barChartOptions = {
        scales: {
          x: {
            grid: {
              display: false,
            }
          },
          y: {
            grid: {
              display: true,
              color: '#DEDEDE',
              // borderColor: 'grey',
              tickColor: 'transparent'
            }
          }
        },
        maintainAspectRatio: false,
        tooltips: { enabled: true, displayColors: false },
        scaleShowVerticalLines: false,
        responsive: true,
      };
      this.barChartLabels = this.gradeNames;
      this.barChartType = "bar";
      this.barChartLegend = false;
      this.barChartData = [
        {
          type:'line',
          data: this.chartMaximumValues,
          borderColor: '#48E3FF',
          borderWidth: 2,
          borderDash: [10, 10],
          pointBackgroundColor:'transparent',
          pointBorderColor:'transparent',
          fill: false,
          tension: 0.5,
        },
        {
          type:'bar',
          data: this.noOfpresentStudentsInEachGrade,
          label: "present",
          backgroundColor: "#1D71D3",
          hoverBackgroundColor: "#1D71D3",
          barPercentage: 0.5,
          barThickness: 10,
          maxBarThickness: 10,
          minBarLength: 2,
          borderRadius:10,
        },
        {
          type:'bar',
          data: this.noOfabsentStudentsInEachGrade,
          label: "absent",
          backgroundColor: "#48E3FF",
          hoverBackgroundColor: "#48E3FF",
          barPercentage: 0.5,
          barThickness: 10,
          maxBarThickness: 10,
          borderRadius:10,
          minBarLength: 2,
        },
      ];
      this.attendanceLoading = false;
    });
    this.dashboardService.getBusesReport().subscribe((res: any) => {
      Object.keys(res).map((key) => {
        this.schoolBusSystem[key] = res[key];
      });
      // horizontal bar
      this.horizontalBarChartOptions = {
        scales: {
          xAxes: [
            {
              ticks: {
                display: false,
                min: 0,
              },
              gridLines: {
                display: false,
                drawBorder: false,
                // lineWidth: 0
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                display: false,
                drawBorder: false,
                // lineWidth: 0
              },
            },
          ],
        },
        maintainAspectRatio: false,
        tooltips: { enabled: true, displayColors: false },
        scaleShowVerticalLines: false,
        responsive: true,
      };
      this.translate.get("init").subscribe((res1) => {
        this.horizontalBarChartLabels = [
          this.translate.instant("dashboard-reports.enrolled"),
          this.translate.instant("dashboard-reports.not-enrolled"),
        ];
      });
      this.translate.onLangChange.subscribe((res2) => {
        this.horizontalBarChartLabels = [
          this.translate.instant("dashboard-reports.enrolled"),
          this.translate.instant("dashboard-reports.not-enrolled"),
        ];
      });
      this.horizontalBarChartType = "horizontalBar";
      this.horizontalBarChartLegend = false;
      this.horizontalBarChartData = [
        {
          data: [
            this.schoolBusSystem?.enrolled_students_count,
            this.schoolBusSystem?.not_enrolled_students_count,
          ],
          label: false,
          backgroundColor: ["#1D71D3", "#A7CDF9"],
          hoverBackgroundColor: ["#1D71D3", "#A7CDF9"],
        },
      ];
      this.schoolLoading = false;
    });
    // on init we get the ids of users that don't use blueride today we save in this array that we don't change
    this.dashboardService.getNotUsingIds(date).subscribe((res) => {
      this.not_using_ids_today = res["user_ids"];
    });
    this.getPickUpReports(date, pickupType);
  }

  openAttendanceReprots() {
    this.dashboardService.setReportType("week");
    this.dashboardService.setDownloadData(false);
    this.router.navigateByUrl("/reports/attendance-reports");
  }

  toggleBtn(activebutton) {
    this.usingBlueride = 0;
    this.notUsingBlueride = 0;
    this.activeBtn = activebutton;
    /*reset the changable array on toggle , so the send message function use the fixed array of today ,
    we used 2 arrays to avoid calling the same api again on toggle.
     */
    this.not_using_ids = [];
    this.pickupLoading = true;
    (this.onDate = moment(new Date()).format("DD-MM")),
      this.getPickUpReports(this.reportFilter.toDate, this.activeBtn);
  }

  sendMessage() {
    let ids = [];
    let formatedIds = [];
    // if we clicked the chart then use the changable array otherwise use the fixed ids array of today
    ids =
      this.not_using_ids.length != 0
        ? this.not_using_ids
        : this.not_using_ids_today;

    // to format ids to be an array of objects ex: [{id:10231}] to be consistant with ids from selecting students , parents or staff
    // ids.forEach((user) => {
    //   let obj: any = {};
    //   obj.id = user;
    //   formatedIds.push(obj);
    // });
    // ids = formatedIds;
    this.messagesService.setPreSelectedUserIds(ids);
    this.messagesService._areMultipleRecepientsSelected.next(true);
    this.messagesService.setSingleRecipientName(null);
    this.router.navigateByUrl("/messages-new/send-messages");
    // this.messagesControl.setMessagedRows(ids);
    // this.router.navigateByUrl("/messages/create-messages");
  }

  chartClicked(event) {
    let index;
    let clickedDate;
    if (event.active.length != 0) {
      index = event.active[0].index;
      clickedDate = this.datesArray[index];
      // override todays values of using and not using when clickng bar on chart to get the corresponding data of the clicked date
      this.usingBlueride = this.pickupReports[clickedDate].active;
      this.notUsingBlueride = this.pickupReports[clickedDate].not_active;
      (this.onDate = moment(new Date(clickedDate)).format("DD-MM")),
        /* we need to get the ids of the users that don't use bluride for each clicked date and store in another array ,
      so now i have 2 arrays > one (doesn't change) with ids of today , the other (change on every chart click) with ids of 
      clicked date.
      */
        this.dashboardService.getNotUsingIds(clickedDate).subscribe((res) => {
          this.not_using_ids = res["user_ids"];
        });
    } else {
      // this.usingBlueride = this.notUsingBlueride = 0;
    }
  }

  getPickUpReports(date, pickupType) {
    this.datesArray = [];
    this.active_users = [];
    this.not_active_users = [];
    this.dashboardService.getUsersUsingStatus(date, pickupType).subscribe(
      (Results: any) => {
        this.pickupReports = Results;
        for (const [key, value] of Object.entries(Results)) {
          this.datesArray.push(key);
          this.active_users.push(value["active"]);
          this.not_active_users.push(value["not_active"]);
        }
        // line chart
        this.lineChartOptions = {
          scales: {
            x: {
              grid: {
                display: false,
              }
            },
            y: {
              grid: {
                display: true,
                color: '#DEDEDE',
                // borderColor: 'grey',
                tickColor: 'transparent'
              }
            }
          },
          maintainAspectRatio: false,
          tooltips: { enabled: true, displayColors: false },
          scaleShowVerticalLines: false,
          responsive: true,
        };
        this.lineChartLabels = this.datesArray;
        this.lineChartType = "line";
        this.lineChartLegend = false;
        this.lineChartData = [
          {
            type:'line',
            data: this.active_users,
            borderColor: '#48E3FF',
            borderWidth: 2,
            borderDash: [10, 10],
            pointBackgroundColor:'transparent',
            pointBorderColor:'transparent',
            fill: false,
            tension: 0.5,
          },
          {
            type:'bar',
            data: this.active_users,
            borderColor: "#1D71D3",
            pointBackgroundColor: "#1D71D3",
            backgroundColor: "#1D71D3",
            hoverBackgroundColor: "#1D71D3",
            fill: false,
            label: this.translate.instant("dashboard-reports.using-blueride"),
            barPercentage: 0.5,
            barThickness: 10,
            maxBarThickness: 10,
            minBarLength: 2,
            borderRadius:10,
          },
          // {
          //   data: this.not_active_users, borderColor: '#a7cdf9', pointBackgroundColor: '#a7cdf9', backgroundColor: '#a7cdf9', hoverBackgroundColor: '#a7cdf9', fill: false , label: this.translate.instant('dashboard-reports.not-using-blueride')
          // },
          
        ];

        // by default i want the using and not using from todays date wich corrospond to the last element in these arrays
        this.usingBlueride = this.active_users[this.active_users.length - 1];
        this.notUsingBlueride =
          this.not_active_users[this.not_active_users.length - 1];
        this.pickupLoading = false;
      },
      (error) => {}
    );
  }

  getMaximum2Arrays(arr1,arr2){
    this.chartMaximumValues = [];
    for (let i = 0; i < arr1.length; i++) {
      this.chartMaximumValues.push(Math.max(arr1[i], arr2[i]));
    }
  }
}
